import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import TableMetaContext from 'src/utils/context/TableMetaContext';
import ColumnPopup from '../ColumnPopup';
import s from './DataGridBaseColumn.styles';

const DataGridBaseColumn = ({
  children,
  name,
  order,
  filter,
  filterType,
  filterValues,
  filterNull,
  onPopupOpenedChange,
  ...rest
}) => {
  const {
    refetch,
    name: tableName,
    variables,
    filters,
    setFilters,
    hideColumnFilter,
  } = useContext(TableMetaContext);
  const [popupOpened, setPopupOpenedReal] = useState(false);
  const setPopupOpened = value => {
    setPopupOpenedReal(value);
    onPopupOpenedChange(value);
  };

  const orderColumn = order === null ? null : order || name;
  const filterColumn = filter === null ? null : filter || name;
  // if filter for a grid is handled using storybook filter then hide column popup if there is no order column
  const hide = (hideColumnFilter && !orderColumn);

  let icon = null;
  if (!hide && tableName && (orderColumn || filterColumn)) {
    icon = <s.ColumnIconArrow />;
  }
  if (variables.orderBy === orderColumn) {
    icon =
      variables.orderDirection === 'asc' ? (
        <s.ColumnArrow>&darr;</s.ColumnArrow>
      ) : (
        <s.ColumnArrow>&uarr;</s.ColumnArrow>
      );
  }

  const onColumnClick = () => {
    if (!hide && (filterColumn || orderColumn)) {
      setPopupOpened(!popupOpened);
    }
  };

  return (
    <div
      {...rest}
      style={{
        pointerEvents: (!hide && tableName && (filterColumn !== null || orderColumn !== null)) ? 'all' : 'none',
      }}
      >
      <div onClick={onColumnClick}>
        {children}
        {icon}
      </div>
      {popupOpened && (
        <ColumnPopup
          {...rest}
          column={{
            filter,
            filterType: filterType || 'text',
            filterValues,
            filterNull,
            label: children,
          }}
          currentOrder={{
            column: variables.orderBy,
            direction: variables.orderDirection,
          }}
          filter={filterColumn}
          filters={filters}
          filterType={filterType || 'text'}
          filterValues={filterValues}
          name={tableName}
          onClose={() => setPopupOpened(false)}
          orderColumn={orderColumn}
          refetch={refetch}
          setFilters={setFilters}
        />
      )}
    </div>
  );
};

DataGridBaseColumn.propTypes = {
  children: PropTypes.any,
  name: PropTypes.string,
  order: PropTypes.string,
  filter: PropTypes.string,
  filterType: PropTypes.string,
  filterValues: PropTypes.array,
  filterNull: PropTypes.string,
  onPopupOpenedChange: PropTypes.func,
};

DataGridBaseColumn.defaultProps = {
  name: null,
  filterNull: null,
};

export default React.memo(DataGridBaseColumn);
